__turbopack_context__.v({
  "alignRight": "dZpOua_alignRight",
  "cell": "dZpOua_cell",
  "cellChevron": "dZpOua_cellChevron",
  "cellWithSubtitle": "dZpOua_cellWithSubtitle",
  "grow": "dZpOua_grow",
  "head": "dZpOua_head",
  "hideOnMMax": "dZpOua_hideOnMMax",
  "hideOnSMax": "dZpOua_hideOnSMax",
  "muted": "dZpOua_muted",
  "row": "dZpOua_row",
  "rowSelected": "dZpOua_rowSelected",
  "selectable": "dZpOua_selectable",
  "sizeLg": "dZpOua_sizeLg",
  "subtitle": "dZpOua_subtitle",
  "table": "dZpOua_table",
});
